import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import store from "./store";
import "@/styles/index.css";
import gapi from "vue-gapi";
// import GAuth from "vue-google-oauth2";
import "@fortawesome/fontawesome-free/css/all.min.css";

// Import the Auth0 configuration
import { domain, clientId } from "../auth_config.json";

// Import the plugin here
import { Auth0Plugin, getInstance } from "./auth0";

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience: "https://api.hippocast.com",
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

const API_URL = process.env.API_URL || "http://localhost:3000/api/v1";
import { HttpPlugin } from "./http";

// const accessToken = await this.$auth.getTokenSilently();

Vue.use(HttpPlugin, {
  apiUrl: API_URL,
  auth: getInstance()
});

Vue.config.productionTip = false;

let discoveryUrl =
  "https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest";
const apiConfig = {
  apiKey: "AIzaSyAQWALkAQP5bK1oecEmtG4kdPixa4mW6sk",
  clientId:
    "632271268937-1lkf2hlcibtdqkg1lrhuosd8thjgpv9l.apps.googleusercontent.com",
  discoveryDocs: [discoveryUrl],
  scope:
    "email https://www.googleapis.com/auth/youtube.upload https://www.googleapis.com/auth/youtube",

  additional_parameters: {
    access_type: "offline", // offline access
    include_granted_scopes: true // incremental auth
  },

  // prompt: "consent",
  // fetch_basic_profile: false

  // works only with `ux_mode: "prompt"`
  refreshToken: true
};

Vue.use(gapi, apiConfig);

new Vue({
  router,
  // store,
  // created() {
  //   store.dispatch("retrieveTokenFromAuth0").then(response => {
  //     store.commit("setToken", response);
  //   });
  // },
  render: h => h(App)
}).$mount("#app");
